import { render, staticRenderFns } from "./refundQuery.vue?vue&type=template&id=4ff20014&scoped=true"
import script from "./refundQuery.vue?vue&type=script&lang=js"
export * from "./refundQuery.vue?vue&type=script&lang=js"
import style0 from "./refundQuery.vue?vue&type=style&index=0&id=4ff20014&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff20014",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff20014')) {
      api.createRecord('4ff20014', component.options)
    } else {
      api.reload('4ff20014', component.options)
    }
    module.hot.accept("./refundQuery.vue?vue&type=template&id=4ff20014&scoped=true", function () {
      api.rerender('4ff20014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/gpt/components/refundQuery.vue"
export default component.exports